import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=4dcff84c&lang=scss&scoped=true"

import exportComponent from "D:\\webSite\\beifen\\repository\\data-show\\wuanxiaomi-datashow\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcff84c"]])

export default __exports__